import { useFormContext, Controller } from 'react-hook-form'
import { Select } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { GRADE_OPTIONS } from '@myap/metadata'
import { FIELD_GRADE } from '../constants'
import { validateFieldState } from '../validations'

function StudentGrade({ disabled }) {
  const { control } = useFormContext()

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <Controller
      control={control}
      name={FIELD_GRADE}
      disabled={disabled}
      rules={{ required: 'Selection is required' }}
      render={({
        field: { onChange, onBlur, value, disabled, name },
        fieldState: { invalid, isDirty, isTouched, error },
      }) => (
        <Select
          name={name}
          label="Current Grade Level"
          labelNoValue="Make a selection"
          required
          disabled={disabled}
          onChange={value => onChange(value)}
          onBlur={value => onBlur(value)}
          value={value}
          values={GRADE_OPTIONS}
          validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
          validationMsg={error?.message}
        />
      )}
    />
  )
}

export default StudentGrade
